var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Checkbox } from '../form';
export var SortableItem = function (_a) {
    var _b;
    var id = _a.id, field = _a.field, configuration = _a.configuration, setConfiguration = _a.setConfiguration;
    var _c = useSortable({
        id: id,
    }), attributes = _c.attributes, listeners = _c.listeners, setNodeRef = _c.setNodeRef, transform = _c.transform, transition = _c.transition, isDragging = _c.isDragging;
    var style = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
    };
    return (_jsx("div", __assign({ ref: setNodeRef, style: style }, attributes, { className: "\n        bg-white p-3 rounded-lg border border-gray-200 mb-2\n        ".concat(isDragging ? 'shadow-lg border-blue-400' : 'shadow-sm hover:shadow-md', "\n        transition-all duration-200 w-full\n      "), children: _jsxs("div", { className: 'flex items-center gap-2', children: [_jsx("div", __assign({ className: 'cursor-grab hover:bg-gray-100 p-2 rounded transition-colors', "aria-label": 'Drag to reorder' }, listeners, { children: _jsxs("div", { className: 'flex flex-col gap-1', children: [_jsx("div", { className: 'w-4 h-0.5 bg-gray-400' }), _jsx("div", { className: 'w-4 h-0.5 bg-gray-400' }), _jsx("div", { className: 'w-4 h-0.5 bg-gray-400' })] }) })), _jsx(Checkbox, { label: field.label, checked: !!((_b = configuration.applyFormFields) === null || _b === void 0 ? void 0 : _b.find(function (f) { return f.name === field.name; })), onChange: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        setConfiguration(function (prev) { return (__assign(__assign({}, prev), { applyFormFields: e.target.checked
                                ? __spreadArray(__spreadArray([], (prev.applyFormFields || []), true), [__assign({}, field)], false) : (prev.applyFormFields || []).filter(function (f) { return f.name !== field.name; }) })); });
                    }, disabled: !field.isConfigurable })] }) })));
};
